import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';











export default function ReviewQuoteDetails({userData, refData}){
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [error, setError] = useState(''); 
    const [popup, setPopup] = useState(false);

    // Handle checkbox toggle
    const handleCheckboxChange = (e) => {
        setIsTermsChecked(e.target.checked);
        setError('');
    };

    const getDOBFromAge = (age) => { 
        const today = new Date();
        const birthYear = today.getFullYear() - age;

        return new Date(birthYear, today.getMonth(), today.getDate());
    };
    const age = Number(userData?.ProposerDetails?.[1] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Age"] : userData?.ProposerDetails?.["Proposer.Person.Age"]);
    const dob = getDOBFromAge(age);
    const ageone = Number(userData?.ProposerDetails?.[1]?.["Proposer.Person.Age"]);
    const dobone = getDOBFromAge(ageone);

     const handleSubmit = (e) => {
        e.preventDefault();
         // Check if terms & conditions checkbox is checked
        if (!isTermsChecked) {
            setError('You must confirm the information by checking the box above.');
            return;
        }
        setPopup(true)
    }
    const isBrokerDiscount = userData?.PaymentDetails?.Charge < 0;
    return(<>
        <div className={`review-quote-popup-main ${popup ? 'hide' : ''}`} >
            <div className='review-quote-popup-content'>
                <h1>Welcome Back <span className='text-capitalize'>({userData?.ProposerDetails?.[1] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Title"]+' '+userData?.ProposerDetails?.[0]?.["Proposer.Person.Surname"]+' '+userData?.ProposerDetails?.[0]?.["Proposer.Person.Forenames"] : userData?.ProposerDetails?.["Proposer.Person.Title"]+' '+userData?.ProposerDetails?.["Proposer.Person.Surname"]+' '+userData?.ProposerDetails?.["Proposer.Person.Forenames"]})</span></h1>
                <p>Review your Full Quote Details Main Proposer</p>
                <h3>Quote Details</h3>
                <ul>
                    <li><b>Reference:</b> {refData.referenceCode}</li>
                    <li><b>Premium:</b> £{Math.abs(userData?.PaymentDetails?.Premium).toFixed(2)}</li>
                    <li><b>{isBrokerDiscount ? "Broker Discount" : "Broker Fee"}:</b> {isBrokerDiscount ? "-" : ""}£{Math.abs(userData?.PaymentDetails?.Charge).toFixed(2)}</li>
                    <li><b>Insurer:</b> {userData?.HomeDetails?.Insurer}</li>
                </ul>
                <h3>Main Proposer Details</h3>
                {userData?.ProposerDetails?.[1] ? 
                <>
                <ul>
                    <li><b>Name:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.Forenames"] + ' ' + userData?.ProposerDetails?.[0]?.["Proposer.Person.Surname"]}</li>
                    <li><b>Contact Number:</b> {userData?.HomeDetails?.Telephone1}</li>
                    <li><b>Alternative Number:</b> {userData?.HomeDetails?.Telephone2} </li>
                    <li><b>Email:</b> {userData?.HomeDetails?.Email}</li> 
                    <li><b>Type Of Cover:</b> {userData?.HomeDetails?.["Policy.Cover"]}</li>
                    <li><b>First Time Buyer:</b> {userData?.HomeDetails?.["Proposers.Proposer.FirstTimeBuyer"]}</li>
                    <li><b>Cover Date:</b> {userData?.HomeDetails?.["Policy.CoverDate"]}</li>
                    <li><b>Proposer is Resident:</b> {userData?.HomeDetails?.["Home.Occupancy.Residence"]}</li>
                    <li><b>Gender:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.Gender"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Gender"] : 'N/A'}</li>
                    <li><b>Age:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.Age"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Age"] : 'N/A'}</li>
                    <li><b>Marital Status:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.MaritalStatus"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.MaritalStatus"] : 'N/A'}</li>
                    <li><b>Employment Status:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.EmpStat"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.EmpStat"] : 'N/A'}</li>
                    <li><b>Occupation:</b>  {userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.OccType"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.OccType"] : 'N/A'}</li>
                    <li><b>Business Type:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.BusType"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.BusType"] : 'N/A'}</li>
                    <li><b>Full/Part time:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.FullPart"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.FullPart"] : 'N/A'}</li>
                    <li><b>Declared Bankrupt:</b> {userData?.HomeDetails?.["Policy.Bankrupt"]}</li>
                    <li><b>Insurance Refused:</b> {userData?.HomeDetails?.["Policy.InsRefused"]}</li>
                </ul>
                <h3>Proposer 2 Details</h3>
                <ul>
                    <li><b>Name:</b> {userData?.ProposerDetails?.[1]?.["Proposer.Person.Forenames"] + ' ' + userData?.ProposerDetails?.[1]?.["Proposer.Person.Surname"]}</li>
                    <li><b>Relationship to Proposer:</b> {userData?.ProposerDetails?.[1]?.["Proposer.PropRelation"]}</li>
                    <li><b>Gender:</b> {userData?.ProposerDetails?.[1]?.["Proposer.Person.Gender"]}</li>
                    <li><b>Age:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.Age"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Age"] : 'N/A'}</li>
                    <li><b>Marital Status:</b> {userData?.ProposerDetails?.[1]?.["Proposer.PropRelation"]}</li>
                    <li><b>Employment Status:</b> {userData?.ProposerDetails?.[1]?.["Proposer.Person.Occupations.Occupation1.EmpStat"] ? userData?.ProposerDetails?.[1]?.["Proposer.Person.Occupations.Occupation1.EmpStat"] : 'N/A'}</li>
                    <li><b>Occupation:</b> {userData?.ProposerDetails?.[1]?.["Proposer.Person.Occupations.Occupation1.OccType"] ? userData?.ProposerDetails?.[1]?.["Proposer.Person.Occupations.Occupation1.OccType"] : 'N/A'}</li>
                    <li><b>Business Type:</b> {userData?.ProposerDetails?.[1]?.["Proposer.Person.Occupations.Occupation1.BusType"] ? userData?.ProposerDetails?.[1]?.["Proposer.Person.Occupations.Occupation1.BusType"] : 'N/A'}</li>
                    <li><b>Full/Part time:</b> {userData?.ProposerDetails?.[1]?.["Proposer.Person.Occupations.Occupation1.FullPart"] ? userData?.ProposerDetails?.[1]?.["Proposer.Person.Occupations.Occupation1.FullPart"] : 'N/A'}</li>
                </ul>
                </>:
                <ul>
                    <li><b>Name:</b> {userData?.ProposerDetails?.["Proposer.Person.Forenames"] + ' ' + userData?.ProposerDetails?.["Proposer.Person.Surname"]}</li>
                    <li><b>Contact Number:</b> {userData?.HomeDetails?.Telephone1}</li>
                    <li><b>Alternative Number:</b> {userData?.HomeDetails?.Telephone2} </li>
                    <li><b>Email:</b> {userData?.HomeDetails?.Email}</li> 
                    <li><b>Type Of Cover:</b> {userData?.HomeDetails?.["Policy.Cover"]}</li>
                    <li><b>First Time Buyer:</b> {userData?.HomeDetails?.["Proposers.Proposer.FirstTimeBuyer"]}</li>
                    <li><b>Cover Date:</b> {userData?.HomeDetails?.["Policy.CoverDate"]}</li>
                    <li><b>Proposer is Resident:</b> {userData?.HomeDetails?.["Home.Occupancy.Residence"]}</li>
                    <li><b>Gender:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.Gender"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Gender"] : 'N/A'}</li>
                    <li><b>Age:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.Age"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Age"] : 'N/A'}</li>
                    <li><b>Marital Status:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.MaritalStatus"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.MaritalStatus"] : 'N/A'}</li>
                    <li><b>Employment Status:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.EmpStat"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.EmpStat"] : 'N/A'}</li>
                    <li><b>Occupation:</b>  {userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.OccType"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.OccType"] : 'N/A'}</li>
                    <li><b>Business Type:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.BusType"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.BusType"] : 'N/A'}</li>
                    <li><b>Full/Part time:</b> {userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.FullPart"] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Occupations.Occupation1.FullPart"] : 'N/A'}</li>
                    <li><b>Declared Bankrupt:</b> {userData?.HomeDetails?.["Policy.Bankrupt"]}</li>
                    <li><b>Insurance Refused:</b> {userData?.HomeDetails?.["Policy.InsRefused"]}</li>
                </ul>
                }

                <h3>Property Details</h3>
                <ul>
                    <li><b>Address 1:</b> {userData?.HomeDetails?.["Home.Address.AddrLine1"]}</li>
                    <li><b>Address 2:</b> {userData?.HomeDetails?.["Home.Address.AddrLine2"]}</li>
                    <li><b>Address 3:</b> {userData?.HomeDetails?.["Home.Address.AddrLine3"] ? userData?.HomeDetails?.["Home.Address.AddrLine3"] : ''}</li>
                    <li><b>Address 4:</b> {userData?.HomeDetails?.["Home.Address.AddrLine4"] ? userData?.HomeDetails?.["Home.Address.AddrLine4"] : ''}</li>
                    <li><b>Postcode:</b> {userData?.HomeDetails?.["Home.Address.AddrPostCode"]}</li>
                    <li><b>Type of Property:</b> {userData?.HomeDetails?.["Home.HouseType"]}</li>
                    <li><b>Self Contained:</b> {userData?.HomeDetails?.["Home.SelfContained"]}</li>
                    <li><b>Number of Floors:</b> {userData?.HomeDetails?.["Home.Floors"]}</li>
                    <li><b>Number of Bedrooms:</b> {userData?.HomeDetails?.["Home.Bedrooms"]}</li>
                    <li><b>Main Heating Method:</b> {userData?.HomeDetails?.["Home.Heating"]}</li>
                    <li><b>Smoke Alarms:</b> {userData?.HomeDetails?.["Home.SmokeAlarm"]}</li>
                    <li><b>Neighbourhood Watch Area:</b> {userData?.HomeDetails?.["Home.HomeWatch"]}</li>
                    <li><b>Approved Window Locks:</b> {userData?.HomeDetails?.["Home.Security.WindowLocks"]}</li>
                    <li><b>Approved French Door Locks:</b> {userData?.HomeDetails?.["Home.Security.Locks.FrenchDoor"]}</li>
                    <li><b>Approved Door Locks:</b> {userData?.HomeDetails?.["Home.Security.OtherDoor"]}</li>
                    <li><b>Property Construction:</b> {userData?.HomeDetails?.["Home.Construction.Construction"]}</li>
                    <li><b>Property Extended:</b> {userData?.HomeDetails?.["Home.Construction.Extended"]}</li>
                    <li><b>Property Listed:</b> {userData?.HomeDetails?.["Home.Construction.Listed"]}</li>
                    <li><b>Roof Type:</b> {userData?.HomeDetails?.["Home.Construction.RoofType"]}</li>
                    <li><b>Percentage of Roof Flat:</b> {userData?.HomeDetails?.["Home.Construction.FlatRoofPC"]}</li>
                    <li><b>Property Condition:</b> {userData?.HomeDetails?.["Home.Construction.GoodRepair"]}</li>
                    <li><b>Year Built:</b> {userData?.HomeDetails?.["Home.Construction.YearBuilt"]}</li>
                    <li><b>Within 400m of River:</b> {userData?.HomeDetails?.["Home.Hazards.RiverQuarry"]}</li>
                    <li><b>Property Unoccupied:</b> {userData?.HomeDetails?.["Home.Occupancy.Unoccupancy"]}</li>
                    <li><b>Proposer Residence Status:</b> {userData?.HomeDetails?.["Home.Occupancy.Residence"]}</li>
                    <li><b>Property Status:</b>{userData?.HomeDetails?.["Home.Occupancy.Accommodation"]}</li>
                    <li><b>Adults in Property:</b> {userData?.HomeDetails?.["Home.Occupancy.Adults"]}</li>
                    <li><b>Children in Property:</b> {userData?.HomeDetails?.["Home.Occupancy.Children"]}</li>
                </ul>

                <h3>Buildings Cover</h3>
                <ul>
                    <li><b>Cover Type:</b> {userData?.HomeDetails?.["Home.Buildings.BCoverType"]}</li>
                    <li><b>Sums Insured:</b> £{userData?.HomeDetails?.["Home.Buildings.BSumInsured"]}</li>
                    <li><b>Buy Back:</b> {userData?.HomeDetails?.["Home.Contents.CBuyBack"]}</li>
                    <li><b>Previous Insurer:</b> {userData?.HomeDetails?.["Home.Contents.CInsurer"]}</li>
                    <li><b>Date Lapsed:</b> {userData?.HomeDetails?.["Policy.CoverDate"]}</li>
                    <li><b>NCB Years:</b> {userData?.HomeDetails?.["Home.Buildings.BYearsInsuredOLD"]}</li>
                    <li><b>NCB Proof:</b> {userData?.HomeDetails?.["Home.Contents.CNCBProof"]}</li>
                    <li><b>Years Insured:</b> {userData?.HomeDetails?.["Home.Contents.CYearsInsuredOLD"]}</li>
                    <li><b>Insurance Refused:</b> {userData?.HomeDetails?.["Policy.InsRefused"]}</li>
                </ul>

                <h3>Contents Cover</h3>
                <ul>
                    <li><b>Total Value of Contents:</b> £{userData?.HomeDetails?.["Home.Contents.CSumInsured"]}</li>
                    <li><b>Cover Required:</b> {userData?.HomeDetails?.["Home.Contents.CCoverType"]}</li>
                    <li><b>Bicycle Cover:</b> {userData?.HomeDetails?.["Home.Contents.BicycleCover"]}</li>
                    <li><b>High Risk Items:</b> {userData?.HomeDetails?.["Home.Contents.HighRisk"]}</li>
                </ul>

                <h3>Unspecified Items</h3>
                <ul>
                    <li><b>Unspecified Value Outside:</b> {userData?.HomeDetails?.["Home.UnspecifiedItems.OutsideValue"]}</li>
                    <li><b>Unspecified Value:</b> £{userData?.HomeDetails?.["Home.UnspecifiedItems.ArEffects.ArEffectsValue"]}</li>
                    <li><b>Expensive Item:</b> £{userData?.HomeDetails?.["Home.UnspecifiedItems.ArEffects.Expensive"]}</li>
                </ul>

                <h3>Claims</h3>
                <ul>
                    <li><b>Type:</b> {userData?.ClaimDetails?.["Claim.ClaimType"]}</li>
                    <li><b>Date:</b> {userData?.ClaimDetails?.["Claim.ClaimDate"]}</li>
                    <li><b>Value:</b> £{userData?.ClaimDetails?.["Claim.ClaimValue"]}</li>
                    <li><b>Circumstance:</b> {userData?.ClaimDetails?.["Claim.ClaimType"]}</li>
                    <li><b>Settled:</b> {userData?.ClaimDetails?.["Claim.ClaimSettled"]}</li>
                </ul>

                <h3>Confirmation</h3>
                <div className='d-flex mt-3'>
                    <Form.Check
                        inline
                        label={null}
                        name="termcondation"
                        type="checkbox"
                        id="termcondation"
                        checked={isTermsChecked}
                        onChange={handleCheckboxChange}
                        className='review-quote-checkbox'
                    />
                    <label htmlFor="termcondation" className="form-check-label review-quote-checkbox-label">
                        I confirm that I have reviewed my quote information above and am satisfied that to the best of my knowledge the information I have provided is correct. I also confirm that I have read and understood our Terms of Business and Policy Information.
                        <a
                            href="https://docs.thamesbankinsurance.co.uk/Terms/Terms%20Of%20Business.pdf"
                            rel="noreferrer"
                            target="_blank"
                            style={{ fontWeight: 'bold', marginLeft: '5px' }}
                        >
                            (See Here)
                        </a>
                    </label>
                </div>
                <p style={{fontSize: '13px'}}><i>*It is important that you check these details to make sure they are correct. If not, please contact us.</i></p>
                {error && <Alert variant="danger" className='mt-3'>{error}</Alert>}
                <button className='btn btn-primary' onClick={handleSubmit}>Submit</button>

            </div>
        </div>
    </>)
}


